export const getUniqueCarriers = (segments) => {
    const carriers = new Map();
    for (const segment of segments) {
        for (const leg of segment.legs) {
            for (const carrier of leg.carriersData) {
                carriers.set(carrier.code, carrier);
            }
        }
    }
    return Array.from(carriers.values());
};
export const uniqueCarriersFromSegments = (segments) => {
    const carriers = [];
    segments.forEach((segment) => {
        segment.legs.forEach((leg) => {
            carriers.push(...leg.carriersData.map((carrier) => carrier.code));
        });
    });
    return [...new Set(carriers)];
};
export const getUniqueMarketingCarriers = (segments) => {
    const carriers = new Map();
    for (const segment of segments) {
        for (const leg of segment.legs) {
            const marketingCarrier = leg.flightInfo?.carrierInfo?.marketingCarrier;
            if (!marketingCarrier || carriers.has(marketingCarrier))
                continue;
            for (const carrier of leg.carriersData) {
                if (carrier.code === marketingCarrier)
                    carriers.set(carrier.code, carrier);
            }
        }
    }
    return Array.from(carriers.values());
};
export function hasMarketingCarrier(segments, airlines) {
    const carriers = getUniqueCarriers(segments);
    return carriers.some((carrier) => airlines.includes(carrier.code));
}
export function hasAnyCarrier(segments, airline) {
    return segments.some((s) => s.legs.some((l) => l.carriers.includes(airline)));
}
export function getMarketingCarriers(segments) {
    const carriers = new Set();
    for (const segment of segments) {
        for (const leg of segment.legs) {
            if (leg.flightInfo?.carrierInfo?.marketingCarrier) {
                carriers.add(leg.flightInfo.carrierInfo.marketingCarrier);
            }
        }
    }
    return Array.from(carriers);
}
